import React from 'react';
import { CHECKOUT_URL, PRODUCT_IMG, PRODUCT_NAME } from './constants';
const modules = [{
  num: '1',
  title: 'VALUTAZIONE CLINICA E PIANIFICAZIONE TERAPEUTICA™',
  description: 'Un sistema completo di valutazioni professionali, profili occupazionali, pianificazione terapeutica, obiettivi clinici, modelli di intervento, schede di osservazione, ragionamento clinico e documentazione pronta per iniziare rapidamente qualsiasi percorso terapeutico.'
}, {
  num: '2',
  title: 'LIBRERIA PROFESSIONALE DI ATTIVITÀ TERAPEUTICHE™',
  description: 'Una raccolta organizzata di attività professionali per motricità fine, funzioni cognitive, integrazione sensoriale, coordinazione, autonomie, attività della vita quotidiana, neurologia, geriatria, pediatria e riabilitazione funzionale, già classificate per obiettivi terapeutici e livelli di difficoltà.'
}, {
  num: '3',
  title: 'PROGRAMMI TERAPEUTICI COMPLETI™',
  description: "Programmi d'intervento già sviluppati per differenti popolazioni cliniche con obiettivi, progressioni, attività, criteri di adattamento e pianificazioni complete che permettono di ridurre drasticamente il tempo dedicato alla preparazione delle sedute."
}, {
  num: '4',
  title: 'ADATTAMENTI, AUSILI E SOLUZIONI FUNZIONALI™',
  description: "Una raccolta professionale di protocolli per adattamenti ambientali, ausili, strategie compensative, ergonomia, conservazione dell'energia, modifiche delle attività e strumenti pratici per migliorare l'autonomia dei pazienti nei diversi contesti di vita."
}, {
  num: '5',
  title: 'STRUMENTI PROFESSIONALI PER IL FOLLOW-UP™',
  description: 'Un sistema completo per monitorare l\'evoluzione del paziente attraverso registri, rivalutazioni, report clinici, schede di monitoraggio, documentazione interdisciplinare e strumenti professionali che facilitano il controllo dei progressi terapeutici.'
}, {
  num: '6',
  title: 'MEGA TOOLKIT DEL TERAPISTA OCCUPAZIONALE™',
  description: 'Una grande raccolta di risorse professionali stampabili, esercizi, schede operative, materiali riutilizzabili, template clinici e strumenti pronti all\'uso per preparare sedute efficaci in pochi minuti e lavorare con maggiore organizzazione e professionalità.'
}];
export function SystemSection() {
  return <section className="bg-white px-4 py-5" data-id="element-151" data-mp="1u7e176kdldx7">
      <div className="mx-auto max-w-4xl" data-id="element-152" data-mp="1pb6u3ag8twdo">
        <div className="mb-3 text-center" data-id="element-153" data-mp="1p815rxffuyj0">
          <p className="mb-1 font-display text-[11px] font-bold uppercase tracking-widest text-brand-navy sm:text-sm" data-id="element-154" data-mp="1l8aiw4t192jr">
            LA SOLUZIONE CHE STAVI CERCANDO
          </p>
          <h2 className="mb-1 font-display text-xl font-extrabold uppercase leading-tight sm:text-3xl" data-id="element-155" data-mp="1bambofe8q2kp">
            UN SISTEMA COMPLETO 6-IN-1 PER TERAPISTI OCCUPAZIONALI
          </h2>
          <div className="mb-2 inline-block rounded-lg bg-brand-navy px-3 py-1.5 text-white shadow-md" data-id="element-156" data-mp="3al48snapekbl">
            <p className="font-display text-xs font-bold tracking-wide sm:text-base" data-id="element-157" data-mp="3d7wkaum7kqad">
              🩺 {PRODUCT_NAME}
            </p>
          </div>
          <p className="mx-auto max-w-3xl text-sm font-medium leading-snug text-brand-slate sm:text-base" data-id="element-158" data-mp="3i5olygcnnqrr">
            Più di una raccolta di attività. Più di una semplice libreria di materiali. {PRODUCT_NAME} è un sistema professionale progettato per permetterti di preparare valutazioni, programmi terapeutici, attività e documentazione in pochi minuti, lavorando ogni giorno con materiale professionale già pronto.
          </p>
        </div>

        <div className="grid gap-2.5 sm:grid-cols-2" data-id="element-159" data-mp="34784bud98fuu">
          {modules.map(m => <a key={m.num} href={CHECKOUT_URL} className="group flex cursor-pointer gap-3 rounded-xl border border-brand-line bg-brand-cloud p-3 shadow-sm transition-all hover:border-brand-navy hover:shadow-md" data-id="element-160" data-mp="349kw0z8te4l3">
              <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-lg bg-brand-navy font-display text-sm font-extrabold text-white transition-colors group-hover:bg-brand-blue" data-id="element-161" data-mp="oerea0s7fwcd">
                {m.num}
              </div>
              <div data-id="element-162" data-mp="vzlep9ntgvuj">
                <h3 className="font-display text-[13px] font-bold leading-tight text-brand-ink sm:text-base" data-id="element-163" data-mp="w04no0vho9wf">
                  ✅ {m.title}
                </h3>
                <p className="mt-0.5 text-xs font-medium leading-snug text-brand-slate sm:text-sm" data-id="element-164" data-mp="r2l9t22pdz50">
                  {m.description}
                </p>
              </div>
            </a>)}
        </div>

        <div className="mt-4 text-center" data-id="element-165" data-mp="1eq3537l6ffcq">
          <a href={CHECKOUT_URL} className="inline-block cursor-pointer" aria-label="Acquista Terapista Occupazionale Pro" data-id="element-166" data-mp="1ep1hy4qvz2en">
            <img src={PRODUCT_IMG} alt="Cofanetto Terapista Occupazionale Pro" className="mx-auto w-full max-w-[240px] object-contain drop-shadow-xl transition-transform duration-200 hover:scale-[1.02]" data-id="element-167" data-mp="19rruuvqyz2tz" />
          </a>
        </div>
      </div>
    </section>;
}